import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SharedModule } from '../shared';
import { CoreModule } from '../core';
import {
  AboutComponent,
  CCIQComponent,
  MPAQComponent,
  ContactComponent,
  FaqComponent,
  HomeComponent,
  HowItWorksComponent,
  LayoutComponent ,
  PricingComponent,
  PrivacyComponent,
  TermsComponent,
} from '.';

const routes: Routes = [
  {
    path: 'cciq',
    component: CCIQComponent
  },
  {
    path: 'mpaq',
    component: MPAQComponent
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: HomeComponent
      },
      {
        path: 'about',
        component: AboutComponent
      },
      {
        path: 'pricing',
        component: PricingComponent
      },
      {
        path: 'faq',
        component: FaqComponent
      },
      {
        path: 'contact',
        component: ContactComponent
      },
      {
        path: 'how-it-works',
        component: HowItWorksComponent
      },
      {
        path: 'privacy',
        component: PrivacyComponent
      },
      {
        path: 'terms',
        component: TermsComponent
      },
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    CoreModule.forChild('home'),
    SharedModule,
  ],
  declarations: [
    AboutComponent,
    CCIQComponent,
    MPAQComponent,
    ContactComponent,
    FaqComponent,
    HomeComponent,
    HowItWorksComponent,
    LayoutComponent,
    PricingComponent,
    PrivacyComponent,
    TermsComponent,
  ],
})
export class MarketingModule { }



// WEBPACK FOOTER //
// ./src/app/marketing/marketing.module.ts